// @flow

import './CustomerContainer.css';

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {BrowserRouter, Route, Redirect, Switch} from 'react-router-dom';
import {logout} from '../../actions/auth';
import {DEMO} from '../../roles.js';
import {fetchOrder, toggleMenu, clear, updateOrder} from '../../actions/customerView';

import CustomerNavbar from '../../components/CustomerNavbar/CustomerNavbar';
import CustomerApartment from '../../components/CustomerApartment/CustomerApartment';
import CustomerFileList from '../../components/CustomerFileList/CustomerFileList';
import CustomerOrderContainer from '../CustomerOrderContainer/CustomerOrderContainer';
import CoverImage from '../../components/CoverImage/CoverImage';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';


export type Props = {
  location: { pathname: string },
  user: Object,
  apartment: ?any,
  order: ?any,
  project: ?any,
  isFetching: boolean,
  showMenu: boolean,
  onLogoutClick: Function,
  toggleMenu: Function,
  fetchOrder: Function,
  clear: Function,
  updateOrder: Function,
  userRole: number,
};

class CustomerContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    const {user} = this.props;

    if (user) {
      this.props.fetchOrder(user.orderId);
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  render() {
    const {
      location: {pathname = ''} = {},
      onLogoutClick,
      toggleMenu,
      project,
      order,
      apartment,
      isFetching,
      showMenu,
      updateOrder,
      userRole,
    } = this.props;

    return (
      <BrowserRouter>
        <div className="CustomerContainer">
          {order && apartment && project &&
            <div>
              <CustomerNavbar
                pathname={pathname}
                showMenu={showMenu}
                toggleMenu={toggleMenu}
                onLogoutClick={onLogoutClick}
                userRole={userRole} />
              {project.coverImage &&
                <div className="project-cover-image">
                  <CoverImage imageId={project.coverImage.id} />
                </div>
              }

              <div className="row content">

                <div className="small-12 large-expand column">
                  <Switch>
                    <Route
                      path={`${pathname}/`}
                      exact={true}
                      render={() =>
                        <CustomerApartment project={project} showWarning={userRole !== DEMO} showDemoText={userRole === DEMO} />
                      } />
                    <Route
                      path={`${pathname}/order`}
                      exact={true}
                      render={() =>
                        <CustomerOrderContainer
                          order={order}
                          project={project}
                          apartment={apartment}
                          updateOrder={updateOrder} />
                      } />
                    <Route
                      path={`${pathname}/files`}
                      exact={true}
                      render={() =>
                        <CustomerFileList
                          label="Filer"
                          apartment={apartment} />
                      } />
                    <Route render={() =>
                      <Redirect to={pathname} />
                    } />
                  </Switch>
                </div>
              </div>
            </div>
          }
          {isFetching &&
            <LoadingIndicator
              isLoading={true}
              isGlobal={true}/>
          }
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = ({
  auth: {
    currentUser: {
      role: userRole,
    },
  },
  customerView: {
    order: {
      order,
      project,
      apartment,
      isFetching,
    },
    showMenu,
  },
}) => ({
  order,
  project,
  apartment,
  isFetching,
  showMenu,
  userRole,
});

const mapDispatchToProps = dispatch => ({
  fetchOrder: id =>
    dispatch(fetchOrder(id)),
  onLogoutClick: () =>
    dispatch(logout()),
  toggleMenu: show =>
    dispatch(toggleMenu(show)),
  clear: () =>
    dispatch(clear()),
  updateOrder: (id, state) =>
    dispatch(updateOrder(id, state)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerContainer);



// WEBPACK FOOTER //
// ./src/containers/CustomerContainer/CustomerContainer.js